var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_wrap",style:(_vm.color)},[_c('div',{staticClass:"other_header"},[_c('div',{staticClass:"other_left"},[_c('svg-icon',{attrs:{"icon-file-name":"return"},on:{"click":_vm.goBack}})],1),_c('div',{staticClass:"other_right"},[_vm._v("欢迎你，"+_vm._s(_vm._f("desensitization")(_vm.nickname)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }